__webpack_require__.p = "/grottochess/";